<template>
  <div class="div-settingkeys" v-if="pRolle==='admin' || pRolle==='superadmin'">
    <v-snackbar
        v-model="notificationsnackbar"
        :timeout="6000"
        :color="notificationcolor"
        :top="true"
        :right="true"
        :vertical="true"
    >
      {{ notificationtext }}
      <v-btn
          color="white"
          text
          @click="notificationsnackbar = false"
      >
        {{ $t("Notification.Schliessen") }}
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-overlay :value="loading">
      <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          :size="50"
          :width="7"
      />
    </v-overlay>
    <div class="bodyheader-accounts">
      <label class="label-bodyheader-accounts">

        <v-icon class="icon-start" color="white">mdi-key-variant</v-icon>
        Keys
      </label>
      <span></span>

    </div>


    <div class="body-settingkeys">


      <div>
        <h3 style="margin: 15px 0">Halalbooking-Key</h3>
        <label>Aktueller Benutzername: {{ halalbookingusername }}</label>
        <v-btn
            v-if="!showHalalEdit"
            color="var(--Primary)"
            outlined
            style="margin-top: 15px"
            @click="showHalalEdit = true"
        >
          Ändern
        </v-btn>
        <template v-else>
          <v-text-field
              label="halalbooking-Benutzername"
              v-model="newHalalUsername"
              outlined
          />

          <v-text-field
              label="halalbooking-Passwort"
              v-model="newHalalPassword"
              outlined
          />
          <v-btn
              :disabled="!canSaveHalal"
              @click="saveHalalKey"
              color="var(--Primary)"
              style="color: white; margin-top: 30px"
          >
            {{ $t("Button.Speichern") }}
          </v-btn>
        </template>
      </div>

      <br>
      <v-divider></v-divider>
      <br>


      <div>

        <h3 style="text-align: start;margin: 15px 0">Google-Maps-Key</h3>
        <label style="text-align: start">Aktueller Schlussel: {{ googleMapsKey }}</label>
        <v-btn
            v-if="!showGoogleEdit"
            color="var(--Primary)"
            outlined
            style="margin-top: 15px"
            @click="showGoogleEdit = true"
        >
          Ändern
        </v-btn>
        <template v-else>
          <v-text-field
              label="Google-Maps-Key"
              v-model="newgoogleKey"
              outlined
          />
          <v-btn
              :disabled="!canSaveGoogle"
              @click="saveGoogleMapsKey"
              color="var(--Primary)"
              style="color: white; margin-top: 30px"
          >
            {{ $t("Button.Speichern") }}
          </v-btn>
        </template>

      </div>

      <br>
      <v-divider></v-divider>
      <br>

      <div>

        <h3 style="text-align: start;margin: 15px 0">PayPal-Key</h3>
        <label style="text-align: start">Aktueller Schlussel: {{ paypalKey }}</label>
        <v-btn
            v-if="!showPaypalEdit"
            color="var(--Primary)"
            outlined
            style="margin-top: 15px"
            @click="showPaypalEdit = true"
        >
          Ändern
        </v-btn>
        <template v-else>
          <v-text-field
              label="PayPal-Key"
              v-model="newPaypalKey"
              outlined
          />
          <v-btn
              :disabled="!canSavePaypal"
              @click="savePaypalKey"
              color="var(--Primary)"
              style="color: white; margin-top: 30px"
          >
            {{ $t("Button.Speichern") }}
          </v-btn>
        </template>

      </div>

      <br>
      <v-divider></v-divider>
      <br>

      <div>

        <h3 style="text-align: start;margin: 15px 0">Curreny-Key</h3>
        <label style="text-align: start">Aktueller Schlussel: {{ currencyKey }}</label>
        <v-btn
            v-if="!showCurrencyEdit"
            color="var(--Primary)"
            outlined
            style="margin-top: 15px"
            @click="showCurrencyEdit = true"
        >
          Ändern
        </v-btn>
        <template v-else>
          <v-text-field
              label="PayPal-Key"
              v-model="newCurrencyKey"
              outlined
          />
          <v-btn
              :disabled="!canSaveCurrency"
              @click="saveCurrencyKey"
              color="var(--Primary)"
              style="color: white; margin-top: 30px"
          >
            {{ $t("Button.Speichern") }}
          </v-btn>
        </template>

      </div>


    </div>

  </div>
</template>

<script>


import {getAllSettings, getSettingByFirmaID, updateSettings} from "@/util/settingsUtil";
import {getUser} from "@/util/Auth";
import {getAdminUser} from "@/util/userUtil";

export default {
  name: "SettingsKeys",
  props: [
    'pLang',
    'pRolle',
  ],
  data() {
    return {
      notificationsnackbar: false,
      notificationtext: "",
      notificationcolor: "grey",
      loading: false,

      halalbookingusername: "",
      halalbookingpassword: "",
      googleMapsKey: "",
      paypalKey: "",
      currencyKey: "",

      newHalalUsername: "",
      newHalalPassword: "",
      newgoogleKey: "",
      newPaypalKey: "",
      newCurrencyKey: "",
      settings: "",
      showHalalEdit: false,
      showGoogleEdit: false,
      showPaypalEdit: false,
      showCurrencyEdit: false


    }
  },
  computed: {
    canSaveHalal() {
      return this.showHalalEdit && (
          (this.newHalalUsername && this.newHalalUsername.trim().length > 0) ||
          (this.newHalalPassword && this.newHalalPassword.trim().length > 0)
      );
    },
    canSaveGoogle() {
      return this.showGoogleEdit && this.newgoogleKey && this.newgoogleKey.trim().length > 0;
    },
    canSavePaypal() {
      return this.showPaypalEdit && this.newPaypalKey && this.newPaypalKey.trim().length > 0;
    },
    canSaveCurrency() {
      return this.showCurrencyEdit && this.newCurrencyKey && this.newCurrencyKey.trim().length > 0;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    notification(text, color) {
      this.notificationsnackbar = true;
      this.notificationtext = text;
      this.notificationcolor = color;
    },
    async saveHalalKey() {
      const hasUsername = this.newHalalUsername && this.newHalalUsername.trim().length > 0;
      const hasPassword = this.newHalalPassword && this.newHalalPassword.trim().length > 0;
      if (!hasUsername && !hasPassword) {
        this.notification("Bitte mindestens ein Feld ausfüllen", "orange");
        return;
      }

      this.loading = true;

      //Hier Halal Key speichern
      let set = {
        ...this.settings
      }
      if (hasUsername) {
        set.halalbookingusername = this.newHalalUsername.trim();
      }
      if (hasPassword) {
        set.halalbookingpassword = this.newHalalPassword.trim();
      }

      await updateSettings(set);


      // this.loading = false;
      this.notification("Speichern erfolgreich", "green");

      await new Promise(resolve => setTimeout(resolve, 1000));
      location.reload();
    },


    async saveGoogleMapsKey() {
      const newKey = this.newgoogleKey && this.newgoogleKey.trim();
      if (!newKey) {
        this.notification("Bitte ein Feld ausfüllen", "orange");
        return;
      }

      this.loading = true;


      //Hier GoogleMaps Key speichern
      let set = {
        ...this.settings,
        googleMapsKey: newKey
      }

      await updateSettings(set);


      // this.loading = false;
      this.notification("Speichern erfolgreich", "green");

      await new Promise(resolve => setTimeout(resolve, 1000));
      location.reload();
    },


    async savePaypalKey() {
      const newKey = this.newPaypalKey && this.newPaypalKey.trim();
      if (!newKey) {
        this.notification("Bitte ein Feld ausfüllen", "orange");
        return;
      }

      this.loading = true;


      //Hier Paypal Key speichern
      let set = {
        ...this.settings,
        paypalKey: newKey
      }

      await updateSettings(set);

      // this.loading = false;
      this.notification("Speichern erfolgreich", "green");

      await new Promise(resolve => setTimeout(resolve, 1000));
      location.reload();
    },


    async saveCurrencyKey() {
      const newKey = this.newCurrencyKey && this.newCurrencyKey.trim();
      if (!newKey) {
        this.notification("Bitte ein Feld ausfüllen", "orange");
        return;
      }

      this.loading = true;
      let set = {
        ...this.settings,
        currencyKey: newKey
      }

      await updateSettings(set);


      this.notification("Speichern erfolgreich", "green");

      await new Promise(resolve => setTimeout(resolve, 1000));
      location.reload();
    }
  },

  async created() {

    this.settings = await getAllSettings();
    this.halalbookingusername = this.settings.halalbookingusername;
    this.googleMapsKey = this.settings.googleMapsKey;
    this.paypalKey = this.settings.paypalKey;
    this.currencyKey = this.settings.currencyKey;


  },

}
</script>

<style scoped>
@import "../css/SettingsKeys.css";

</style>
